import { GetterTree } from 'vuex';
import { MessagesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<MessagesState, RootState> = {};
